import { FC } from 'react'

import { Text } from '../../UI'

const TableText:FC = ({ children }) => <Text component="span" size="14">{children}</Text>

export { TableText }